import "./saga";
import { getRatingsTypes } from "./helpers";
export * from "./slice";
export * from "./helpers";

const getMitigatorState = (state) => state.mitigator;

export const getSourceList = (state) => {
  const _state = getMitigatorState(state);
  return _state.sourcesList;
};

export const getThreatTypesList = (state) => {
  const _state = getMitigatorState(state);
  return _state.threatTypesList;
};

export const getThreatsList = (state) => {
  const _state = getMitigatorState(state);
  return _state.threatsList;
};

export const getVulnerabilitiesList = (state) => {
  const _state = getMitigatorState(state);
  return _state.vulnerabilitiesList;
};

export const getAssetsList = (state) => {
  const _state = getMitigatorState(state);
  return _state.assetsList;
};

export const getAssetTypesList = (state) => {
  const _state = getMitigatorState(state);
  return _state.assetTypesList;
};
export const getRatingsList = (state) => {
  const _state = getMitigatorState(state);
  return _state.ratingsList;
};

export const getRatingListByType = (type, state) => {
  const _state = getMitigatorState(state);
  const ratingsTypes = getRatingsTypes(state);
  const result = _state.ratingsList?.[type] || [];
  return result.map((item) => {
    const ratingType = ratingsTypes.find((type) => type.id.toLowerCase() === item.rating.toLowerCase());
    return {
      ...item,
      rating: {
        id: ratingType ? ratingType.dotIconName : "ABANDONED",
        label: ratingType ? ratingType.label : item.rating,
        _id: ratingType ? ratingType.id : item.rating,
      },
    };
  });
};

export const getReferencesList = (state) => {
  const _state = getMitigatorState(state);
  return _state.referencesList;
};
export const getSourcesByStatus = (status, state) => {
  const _state = getMitigatorState(state);
  const key = (status || "draft").toString().toLowerCase();
  const active = _state.activeSources ?? _state.sourcesList?.active ?? [];
  const draft = _state.draftSources ?? _state.sourcesList?.draft ?? [];
  const archive = _state.archiveSources ?? _state.sourcesList?.archive ?? [];

  if (key === "active") return active;
  if (key === "archive" || key === "archived") return archive;
  return draft;
};

export const getThreatTypesByStatus = (status, state) => {
  const _state = getMitigatorState(state);
  const key = (status || "draft").toString().toLowerCase();
  const active = _state.activeThreatTypes ?? _state.threatTypesList?.active ?? [];
  const draft = _state.draftThreatTypes ?? _state.threatTypesList?.draft ?? [];
  const archive = _state.archiveThreatTypes ?? _state.threatTypesList?.archive ?? [];
  if (key === "active") return active;
  if (key === "archive" || key === "archived") return archive;
  return draft;
};
export const getThreatsByStatus = (status, state) => {
  const _state = getMitigatorState(state);
  const key = (status || "draft").toString().toLowerCase();
  const active = _state.activeThreats ?? _state.threatsList?.active ?? [];
  const draft = _state.draftThreats ?? _state.threatsList?.draft ?? [];
  const archive = _state.archiveThreats ?? _state.threatsList?.archive ?? [];
  if (key === "active") return active;
  if (key === "archive" || key === "archived") return archive;
  return draft;
};
export const getVulnerabilitiesByStatus = (status, state) => {
  const _state = getMitigatorState(state);
  const key = (status || "draft").toString().toLowerCase();
  const active = _state.activeVulnerabilities ?? _state.vulnerabilitiesList?.active ?? [];
  const draft = _state.draftVulnerabilities ?? _state.vulnerabilitiesList?.draft ?? [];
  const archive = _state.archiveVulnerabilities ?? _state.vulnerabilitiesList?.archive ?? [];
  if (key === "active") return active;
  if (key === "archive" || key === "archived") return archive;
  return draft;
};
export const getReferencesByStatus = (status, state) => {
  const _state = getMitigatorState(state);
  const key = (status || "draft").toString().toLowerCase();
  const active = _state.activeReferences ?? _state.referencesList?.active ?? [];
  const draft = _state.draftReferences ?? _state.referencesList?.draft ?? [];
  const archive = _state.archiveReferences ?? _state.referencesList?.archive ?? [];
  if (key === "active") return active;
  if (key === "archive" || key === "archived") return archive;
  return draft;
};
export const getCurrentSource = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentSource;
};
export const getCurrentThreatType = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentThreatType;
};
export const getCurrentThreat = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentThreat;
};
export const getCurrentVulnerability = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentVulnerability;
};
export const getCurrentAsset = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentAsset;
};
export const getCurrentAssetType = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentAssetType;
};
export const getCurrentReference = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentReference;
};

export const getRisksList = (status, state) => {
  const _state = getMitigatorState(state);
  return _state.risksList.filter((risk) => (risk.status || "").toLowerCase() === status.toLowerCase());
};

export const getCurrentRisk = (state) => {
  const _state = getMitigatorState(state);
  return _state.currentRisk;
};

export const isRiskArchived = (state) => {
  const currentRisk = getCurrentRisk(state);
  return Boolean(currentRisk ? currentRisk.status === "archive" : false);
};

export const getImportResult = (state) => {
  const _state = getMitigatorState(state);
  return _state.importResult;
};

export const getSeverityByScore = (iSeverities, score) => {
  const severities = iSeverities.slice().reverse();
  return severities[score] ? severities[score].id : "None";
};
